import React from "react";
import { TableHead } from "@/components/ui/table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

export type SortDirection = "asc" | "desc" | null;

export interface SortableTableHeaderProps {
  column: string;
  label: string;
  sortKey: string | null;
  sortDirection: SortDirection;
  onSort: (column: string) => void;
  className?: string;
}

export function SortableTableHeader({
  column,
  label,
  sortKey,
  sortDirection,
  onSort,
  className,
}: SortableTableHeaderProps) {
  const isCurrentSortColumn = sortKey === column;

  return (
    <TableHead 
      className={cn("cursor-pointer hover:bg-muted/50", className)}
      onClick={() => onSort(column)}
    >
      <div className="flex items-center">
        {label}
        <span className="ml-2">
          {isCurrentSortColumn ? (
            sortDirection === "asc" ? (
              <ArrowUp className="h-4 w-4" />
            ) : (
              <ArrowDown className="h-4 w-4" />
            )
          ) : (
            <ArrowUpDown className="h-4 w-4 opacity-50" />
          )}
        </span>
      </div>
    </TableHead>
  );
}